enum FileCategoryGroupEnum {
  AUTHORITY = 3,
  LAWYER = 9,
  OTHER = 5,
  RENTAL = 4,
  REPAIR = 2,
  VEHICLE = 1
}

export default FileCategoryGroupEnum;
